export const reactSelectLight = {
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? '#0e4535' : '#ced4da',
    height: '42px',
    color: '#000000',
    boxShadow: 'none',
    '&:hover': {
      borderColor: '#0e4535'
    }
  }),

  menu: (base) => ({
    ...base,
    backgroundColor: '#ffffff',
    color: '#000000',
    borderRadius: 6,
    marginTop: 4,
    zIndex: 9999
  }),

  option: (base, { isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isSelected ? '#e8f0ed' : isFocused ? '#e8f0ed' : '#ffffff',
    color: isSelected ? '#0e4535' : '#000000',
    fontWeight: isSelected ? 600 : base.fontWeight,
    cursor: 'pointer',
    fontSize: '0.85rem'
  }),

  singleValue: (base) => ({
    ...base,
    color: '#000000'
  }),

  placeholder: (base) => ({
    ...base,
    color: '#6c757d'
  }),

  valueContainer: (base) => ({
    ...base,
    height: '32px',
    padding: '0 6px'
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: '32px'
  })
};
